/*
 * @Author: your name
 * @Date: 2021-10-25 14:50:58
 * @LastEditTime: 2021-11-09 10:05:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\Xunzhangshu_Website\xzswebsite\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: "勋章树官网"
        }
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: function() {
            return import ( /* webpackChunkName: "about" */ '../components/about.vue')
        },
        meta: {
            title: "关于我们"
        }
    },
    {
        path: '/join',
        name: 'Join',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: function() {
            return import ( /* webpackChunkName: "about" */ '../components/join.vue')
        },
        meta: {
            title: "加入我们"
        }
    },
    {
        path: '/enterprise',
        name: 'Enterprise',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: function() {
            return import ( /* webpackChunkName: "about" */ '../components/enterprise.vue')
        },
        meta: {
            title: "企业服务"
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router